//项目新增
import React, { useState, useEffect } from 'react';
import { Button, Form, Input, InputNumber, DatePicker, Space, message, Card, Select, Spin } from 'antd';
import { addProjectAPI } from '@/apis/project';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getManagerListByUserIdAPI } from '@/apis/user';
// 初始化阶段暂不需要导航跳转，可后续扩展

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select

const onOk = (value) => {
};

const layout = {
    labelCol: {
        span: 6,
        style: {
            whiteSpace: 'normal',
            lineHeight: '1.4',
            textAlign: 'right',
            fontWeight: '500',
            paddingRight: '12px',
        }
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};


// 仅用于初始化阶段的项目创建
async function AddProjectByForm(data) { return await addProjectAPI(data) }

const AddProject = () => {
    const [loading] = useState(false); // 预留 loading，将来可在提交时置为 true
    const [form] = Form.useForm();
    // 项目起止日期字符串（可选记录）
    // 记录日期字符串（目前未直接展示，可后续扩展）
    const [ , setDataString] = useState([])
    const [messageApi, contextHolder] = message.useMessage();
    const info = (msg) => {
        messageApi.info(msg);
    };
    const error = (msg) => {
        messageApi.error(msg);
    };
    // requestError 保留需求时再添加

    const { t } = useTranslation();

    // 清空函数
    function clearData() { setDataString([]) }

    const onFinish = async (values) => {

        // //通过接口上传文件
        // const uploadFileResult = await uploadFileByAPI(file)
        // if (!uploadFileResult) {
        //   return;
        // }

    const { projectName, projectInfo, projectManager, uavNum, uavType, city, projectStartEndDate } = values


        if (!projectStartEndDate || projectStartEndDate.length !== 2) {
            error("请选择项目开始和结束时间");
            return;
        }

        // 格式化日期为字符串
    const formattedDates = projectStartEndDate.map(date => date.format("YYYY-MM-DDTHH:mm:ss.SSS"));

        const data = {
            projectName,
            projectManager,
            uavNum,
            uavType,
            city, // 新增字段：执飞城市
            projectInfo, // 可选
            projectStartTime: formattedDates[0],
            projectEndTime: formattedDates[1],
        }

        const res = await AddProjectByForm(data)

        if (res.code === 0) {
            clearData();
            onReset();
            info(res.msg);
        } else error(res.msg, res.code);
    }

    const onReset = () => {
        form.resetFields();
        setDataString([]);
    };

    const [managerList, setManagerList] = useState([])
    const userId = useSelector(state => state.user.userInfo.userId)

    useEffect(() => {
        async function fetchManagers(uid) {
            if (!uid) return
            try { const res = await getManagerListByUserIdAPI(uid); setManagerList(res.data) } catch (e) { console.error(e) }
        }
        fetchManagers(userId)
    }, [userId])

    return (
        <Card
            style={{
                width: '100%',
                minHeight: '100%',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                overflow: 'hidden'
            }}
            title={t('ProjectAdditionFormList.Title')}
            styles={{ body: { padding: 0, height: '100%', overflow: 'auto' } }}
        >
            <Spin spinning={loading} size='large' />
            <div style={{ width: '100%', padding: 20, maxHeight: 'calc(100vh - 120px)', overflowY: 'auto' }}>
                {contextHolder}
                <Form
                    {...layout}
                    form={form}
                    name='project-init'
                    onFinish={onFinish}
                    style={{ width: '100%', maxWidth: 800, margin: '0 auto' }}
                    size='large'
                >
                    <Form.Item
                        name='projectName'
                        label={t('ProjectAdditionFormList.ProjectName')}
                        rules={[{ required: true, message: t('ProjectAdditionFormList.ProjectNameMessage') }]}
                        style={{ marginBottom: 20 }}
                    >
                        <Input placeholder={t('ProjectAdditionFormList.ProjectNamePlaceholder')} style={{ borderRadius: 6 }} />
                    </Form.Item>

                    <Form.Item
                        name='projectManager'
                        label={t('ProjectAdditionFormList.ProjectManager')}
                        rules={[{ required: true, message: t('ProjectAdditionFormList.ProjectManagerMessage') }]}
                        style={{ marginBottom: 20 }}
                    >
                        <Select placeholder={t('ProjectAdditionFormList.ProjectManagerPlaceholder')} style={{ borderRadius: 6 }}>
                            {managerList.map(item => (
                                <Option key={item.userId} value={item.userId}>{item.userName}</Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name='uavNum'
                        label={t('ProjectAdditionFormList.UavNum')}
                        rules={[{ required: true, message: t('ProjectAdditionFormList.UavNumMessage') }, {
                            validator: (_, v) => (v > 0 ? Promise.resolve() : Promise.reject(new Error('无人机数量必须大于1'))) } ]}
                        style={{ marginBottom: 20 }}
                    >
                        <InputNumber placeholder={t('ProjectAdditionFormList.UavNumPlaceholder')} style={{ width: '100%', borderRadius: 6 }} min={1} />
                    </Form.Item>

                    <Form.Item
                        name='uavType'
                        label={t('ProjectAdditionFormList.UavType')}
                        rules={[{ required: true, message: t('ProjectAdditionFormList.UavTypeMessage') }]}
                        style={{ marginBottom: 20 }}
                    >
                        <Select 
                            placeholder={t('ProjectAdditionFormList.UavTypePlaceholder')} 
                            style={{ borderRadius: 6 }} 
                            options={[
                                { value: '千机Ⅱ', label: '千机Ⅱ' },
                                { value: '千机Ⅲ', label: '千机Ⅲ' },
                                { value: '千机C5', label: '千机C5'},
                                { value: '大漠大V3', label: '大漠大V3' }
                            ]} 
                        />
                    </Form.Item>

                    <Form.Item
                        name='city'
                        label={t('ProjectAdditionFormList.ExecPlace') || '城市'}
                        rules={[{ required: true, message: t('ProjectAdditionFormList.ExecPlaceMessage') || '请输入执飞城市' }]}
                        style={{ marginBottom: 20 }}
                    >
                        <Input placeholder={t('ProjectAdditionFormList.ExecPlacePlaceholder') || '执飞城市'} style={{ borderRadius: 6 }} />
                    </Form.Item>

                    <Form.Item
                        name='projectStartEndDate'
                        label={t('ProjectAdditionFormList.ProjectStartEndDate')}
                        rules={[{ required: true, message: t('ProjectAdditionFormList.ProjectStartEndDateMessage') }]}
                        style={{ marginBottom: 20 }}
                    >
                        <RangePicker
                            format='YYYY-MM-DD'
                            onChange={(_, dateString) => setDataString(dateString)}
                            onOk={onOk}
                            style={{ width: '100%', borderRadius: 6 }}
                            placeholder={[t('ProjectAdditionFormList.ProjectStartDatePlaceholder'), t('ProjectAdditionFormList.ProjectEndDatePlaceholder')]}
                        />
                    </Form.Item>

                    <Form.Item name='projectInfo' label={t('ProjectAdditionFormList.ProjectDescription')} style={{ marginBottom: 30 }}>
                        <TextArea showCount maxLength={100} placeholder={t('ProjectAdditionFormList.ProjectDescriptionPlaceholder')} style={{ height: 100, resize: 'none', borderRadius: 6 }} />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Space size='large' style={{ justifyContent: 'center', width: '100%' }}>
                            <Button type='primary' htmlType='submit' size='large' style={{ background: 'linear-gradient(135deg,#667eea 0%,#764ba2 100%)', border: 'none', borderRadius: 6, padding: '0 40px', height: 44, fontWeight: 500, boxShadow: '0 4px 12px rgba(102,126,234,0.4)' }}>{t('ButtonList.Submit')}</Button>
                            <Button htmlType='button' onClick={onReset} size='large' style={{ borderRadius: 6, padding: '0 40px', height: 44, fontWeight: 500 }}>{t('ButtonList.Reset')}</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </Card>
    );
};
export default AddProject;